import i18next from 'i18next';
import { CardType } from 'services/checkout-service/models';

export const getIconNameForCardType = (cardBrand?: CardType): string => ({
  VISA: 'visa',
  MC: 'mastercard',
  AMEX: 'amex',
  DISCOVER: 'discover',
  DINERS_CLUB: 'dinersClub',
  JCB: 'jcb',
  UNKNOWN: 'unknown',
} as Record<Partial<CardType>, string>)[cardBrand || 'UNKNOWN'] || 'unknown';

export const getTranslatedCardTypeName = (cardBrand?: CardType) => {
  const key = {
    VISA: 'visa',
    MC: 'mastercard',
    AMEX: 'amex',
    DISCOVER: 'discover',
    DINERS_CLUB: 'dinersClub',
    JCB: 'jcb',
    MAESTRO: 'maestro',
    SOLO: 'solo',
    LASER: 'laser',
    CHINA_UNION_PAY: 'chinaUnionPay',
    CARTE_BLANCHE: 'carteBlanche',
    GIFT_CARD: 'giftCard',
    EBT: 'ebt',
    GIROCARD: 'girocard',
    INTERAC: 'interac',
    OTHER: 'undetermined',
    UNKNOWN: 'undetermined',
  }[cardBrand || 'UNKNOWN'];

  return i18next.t(`common:cardNetwork.${key}`);
};
